<template>
    <div>
        <v-rect
          :config="markerBox"
          @mouseenter="onEnter"
          @mousemove="onMove"
          @mouseleave="onLeave"
        ></v-rect>
        <v-text
          :config="markerText"
          @mouseenter="onEnter"
          @mousemove="onMove"
          @mouseleave="onLeave"
        ></v-text>
        <v-line :config="line"></v-line>
    </div>
</template>
<script>
import { smartPruneNumber } from '@/utils/number'

export default {
    name:'BarChartMarker',
    data:()=>({
        canvas: null,
    }),
    methods:{
        displayTextWidth(text) {
            const font = 'normal 12px Inter'
            let canvas = this.canvas || (this.canvas = document.createElement("canvas"));
            let context = canvas.getContext("2d");
            context.font = font;
            let metrics = context.measureText(text);
            return metrics.width;
        },
        clientPoint(evt) {
            const native = (evt && evt.evt) || evt || {}
            return {
                x: Number(native.clientX) || 0,
                y: Number(native.clientY) || 0,
            }
        },
        tipPayload(evt) {
            const point = this.clientPoint(evt)
            return {
                name: this.name,
                value: this.formattedValue,
                color: this.color,
                x: point.x,
                y: point.y,
            }
        },
        onEnter(evt) {
            this.$emit('marker-hover', this.tipPayload(evt))
        },
        onMove(evt) {
            this.$emit('marker-hover', this.tipPayload(evt))
        },
        onLeave() {
            this.$emit('marker-leave')
        },
    },
    computed:{
        effectiveMarkerHeight(){
            return this.markerHeight - 2
        },
        formattedValue(){
            if (this.displayValue === undefined || this.displayValue === null || this.displayValue === '') {
                return ''
            }
            const n = Number(this.displayValue)
            if (!Number.isFinite(n)) {
                return String(this.displayValue)
            }
            return String(smartPruneNumber(n))
        },
        labelText(){
            if (!this.formattedValue) {
                return this.name
            }
            return `${this.name}: ${this.formattedValue}`
        },
        markerText(){
            return {
                    x: this.from.x,
                    y: Math.max( this.from.y - this.effectiveMarkerHeight,0) - 2  ,
                    text: this.labelText,
                    fontSize: 12,
                    fontFamily: 'Inter',
                    fill: this.isSelected ? 'white' : (this.$vuetify && this.$vuetify.theme && this.$vuetify.theme.dark ? '#f3f4f6' : '#111827'),
                    padding: 6,
            }    
        },
        markerBox(){
            return {  
                x: this.from.x,
                y: Math.max(this.from.y - this.effectiveMarkerHeight, 0 ),
                width: this.displayTextWidth(this.labelText) + 12,
                height: this.effectiveMarkerHeight,
                fill: this.color,
                cornerRadius:  this.isSelected ? [6, 6, 6, 6] : [6, 6, 0, 0],
            }
        },
        labelWidth(){
            return this.displayTextWidth(this.labelText)
        },
        line(){
            return {
                x: 0 ,
                y: 0 ,
                points: this.dir=='LEFT' ? [ this.isSelected ? this.from.x + this.labelWidth + 10 : this.from.x , 
                          this.isSelected ? this.from.y -10: this.from.y , 
                         this.from.x + this.labelWidth + 20 , 
                          this.isSelected ? this.from.y -10: this.from.y , 
                         this.to.x , 
                         this.to.y +1,  
                         this.to.x + 45 , 
                         this.to.y +1 ] : [
                            this.from.x + this.labelWidth + 10, 
                            this.from.y , 
                            this.from.x - 10 , 
                            this.from.y , 
                            this.to.x , 
                            this.to.y +1,  
                            this.to.x - 40 , 
                            this.to.y +1
                         ],
                stroke: this.isSelected ? '#0d9488' : (this.$vuetify.theme.isDark ? '#9ca3af' : '#6b7280'),
                strokeWidth: 0.4,
                tension: 0.1,
                dash: this.isSelected ? [0] : [3, 3]
            } 
        }
    },
    props:{
        isSelected:{
            Type: Boolean,
            default: false
        },
        markerHeight:{
            Type: Number,
            default: 20
        },
        name:{
            type: String,
            required: true
        },
        displayValue:{
            type: [Number, String],
            default: null
        },
        to:{
            type: Object,
            required: true
        },
        from:{
            type: Object,
            required: true
        },
        dir:{
            type:String, 
            default: 'LEFT'
        },
        color: {
            type: String,
            required: true
        }
    }
}
</script>
